import { OrderExtra } from '@euler/app/flows/order/types';
import { VehicleServiceInfo } from '@euler/services/vehicle-info.service';
import { BehaviorSubject } from 'rxjs';

export type Mode = 'plate' | 'vin';
export const Modes: Mode[] = ['plate', 'vin'];
export const ModeNameMap: { [p in Exclude<Mode, 'both'>]: string } = {
  plate: '车牌号',
  vin: 'VIN码',
};

export type PlateVinScanProps = {
  mode: Mode;
  modal?: boolean;
  orderDetail$: BehaviorSubject<OrderExtra>;
  onConfirm?: (
    mode: Mode,
    value: string,
    imageUrl: string | undefined,
    serviceInfo?: VehicleServiceInfo,
  ) => void;
};
